import React, { useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isGlobalPhoneMaskingEnabled, setGlobalPhoneMaskingEnabled } from '../utils/numberMasking';

const TopBar = ({ clientId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMaskingEnabled, setMobileMaskingEnabled] = useState(isGlobalPhoneMaskingEnabled());

  const session = useMemo(() => {
    const raw = sessionStorage.getItem('rbac_session');
    return raw ? JSON.parse(raw) : null;
  }, []);

  const rbacRole = useMemo(() => {
    if (!session?.token) return null;
    try {
      const payload = JSON.parse(atob(session.token.split('.')[1]));
      // JWT fallback: if backend didn't include can_manage_roles in token,
      // fall back to sessionStorage value saved by Login.js
      const canManage = payload.can_manage_roles === true 
        || payload.can_manage_roles === 'true'
        || session.can_manage_roles === true;
      return {
        id: payload.role_id,
        username: payload.username,
        role_name: payload.role_name,
        can_manage_roles: canManage
      };
    } catch (e) {
      console.error('JWT decode failed:', e);
      return null;
    }
  }, [session]);

  const handleLogout = () => {
    sessionStorage.removeItem('rbac_session');
    navigate('/');
  };

  const currentPath = location.pathname;
  const leadsPath = `/portal/${clientId}/leads`;
  const teamPath = `/portal/${clientId}/my-team`;

  const handleMobileMaskingToggle = () => {
    const nextValue = !mobileMaskingEnabled;
    setGlobalPhoneMaskingEnabled(nextValue);
    setMobileMaskingEnabled(nextValue);
    window.location.reload();
  };

  return (
    <div style={{
      backgroundColor: '#7C3AED', color: '#fff',
      padding: '10px 24px', display: 'flex', flexWrap: 'wrap',
      justifyContent: 'space-between', alignItems: 'center',
      boxShadow: '0 2px 8px rgba(124,58,237,0.3)',
      minHeight: '64px', gap: '12px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap', flex: '1 1 auto' }}>
        <div style={{ minWidth: '150px' }}>
          <div style={{ fontSize: '18px', fontWeight: '700', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '8px' }}>
            Madocks Portal
            {session?.extension_number && (
              <span style={{ fontSize: '11px', backgroundColor: 'rgba(255,255,255,0.2)', padding: '2px 6px', borderRadius: '4px', fontWeight: '600', letterSpacing: '0.5px' }}>
                Ext: {session.extension_number}
              </span>
            )}
          </div>
          <div style={{ fontSize: '12px', opacity: 0.85, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '200px' }}>
            Welcome, {rbacRole?.username || '...'} {rbacRole?.role_name ? `· ${rbacRole.role_name}` : ''}
          </div>
        </div>

        {/* Navigation Tabs */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
          <button
            type="button"
            onClick={() => navigate(leadsPath)}
            style={{
              background: currentPath === leadsPath ? 'rgba(255,255,255,0.2)' : 'transparent',
              border: 'none', borderBottom: currentPath === leadsPath ? '3px solid white' : '3px solid transparent',
              color: 'white', padding: '10px 16px', fontSize: '14px', fontWeight: '600',
              cursor: 'pointer', transition: 'all 0.2s', borderRadius: '0px'
            }}
          >
            My Leads
          </button>
          
          {rbacRole?.can_manage_roles && (
            <button
              type="button"
              onClick={() => navigate(teamPath)}
              style={{
                background: currentPath === teamPath ? 'rgba(255,255,255,0.2)' : 'transparent',
                border: 'none', borderBottom: currentPath === teamPath ? '3px solid white' : '3px solid transparent',
                color: 'white', padding: '10px 16px', fontSize: '14px', fontWeight: '600',
                cursor: 'pointer', transition: 'all 0.2s', borderRadius: '0px'
              }}
            >
              My Team
            </button>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
        <button
          type="button"
          onClick={handleMobileMaskingToggle}
          style={{
            backgroundColor: mobileMaskingEnabled ? '#f3e8ff' : 'rgba(255,255,255,0.15)',
            color: mobileMaskingEnabled ? '#4c1d95' : '#fff',
            border: '1px solid rgba(255,255,255,0.4)',
            borderRadius: '999px',
            padding: '7px 14px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '700',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
          title={mobileMaskingEnabled ? 'Turn mobile masking off' : 'Turn mobile masking on'}
        >
          <span>{mobileMaskingEnabled ? '🔒 Mask On' : '🔓 Mask Off'}</span>
        </button>

        <button type="button" onClick={handleLogout} style={{
          backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff',
          border: '1px solid rgba(255,255,255,0.4)', borderRadius: '0px',
          padding: '6px 16px', cursor: 'pointer', fontSize: '13px',
          flexShrink: 0
        }}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default TopBar;
